import * as React from "react";
import { render } from "react-dom";
import ImageGallery from 'react-image-gallery';

const images = [
  {
    original: require('./assets/gdc/lieux/chateau-clos.jpg'),
    description: 'Chateau des clos',
  },
  {
    original: require('./assets/gdc/lieux/14-armenon.jpg'),
    description: 'La ferme d\'armenon',
  },
  {
    original: require('./assets/gdc/lieux/close-passerelle.jpg'),
    description: 'Clos des Passerelles',
  },
  {
    original: require('./assets/gdc/lieux/lieu-entreprise.png'),
    description: 'Ferme de Bouchemont',
  },
  {
    original: require('./assets/gdc/lieux/13-grange.jpg'),
    description: 'Espace grange',
  },
  {
    original: require('./assets/gdc/lieux/15-ferme-du-parc.jpg'),
    description: 'Ferme du parc',
  },
  {
    original: require('./assets/gdc/lieux/6-breuil.jpg'),
    description: 'Château du Breuil',
  },
  {
    original: require('./assets/gdc/lieux/petit-moulin.png'),
    description: 'Le petit Moulin des Vaux de Cernay',
  },
  {
    original: require('./assets/gdc/lieux/domaine-de-meauce.jpg'),
    description: 'Domaine de Meaucé',
  },
  // {
  //   original: require('./assets/gdc/lieux/7-c-neuville.jpg'),
  //   description: 'Relais de Neuville',
  // },
  {
    original: require('./assets/gdc/lieux/8-pontarme.jpg'),
    description: 'Château de Pontarmé',
  },

  {
    original: require('./assets/gdc/lieux/2-senlisse.jpg'),
    description: 'Château cour Senlisse',
  },
  {
    original: require('./assets/gdc/lieux/5-mauvieres.jpg'),
    description: 'Château de Mauvières',
  },
  {
    original: require('./assets/gdc/lieux/3-dommerville.jpg'),
    description: 'Château de dommerville',
  },
  {
    original: require('./assets/gdc/lieux/19-dampierre.jpg'),
    description: 'Moulin de Dampierre',
  },
  {
    original: require('./assets/gdc/lieux/4-deviliers.jpg'),
    description: 'Château de Villiers',
  },
  {
    original: require('./assets/gdc/lieux/17-garel.jpg'),
    description: 'Ferme Garel',
  },
  {
    original:  require('./assets/gdc/lieux/1-bateaux-de-paris.jpg'),
    description: 'Bateaux de Paris',
  },
  {
    original: require('./assets/gdc/lieux/7-neuville.jpg'),
    description: 'Château Neuville',
  },

  {
    original: require('./assets/gdc/lieux/ferme-des-jallots.jpg'),
    description: 'Ferme des jallots',
  },
  {
    original: require('./assets/gdc/lieux/domaine-de-ronsard.jpg'),
    description: 'Domaine de Ronsard',
  },
  {
    original: require('./assets/gdc/lieux/Ferme-du-coudray.jpg'),
    description: 'La Ferme du Coudray',
  },
  {
    original: require('./assets/gdc/lieux/relais-neuville.jpg'),
    description: 'Le Relais de Neuville',
  },
  {
    original: require('./assets/gdc/lieux/coccinelles.jpg'),
    description: 'Domaine des coccinelles',
  },
  {
    original: require('./assets/gdc/lieux/tourelles-fonville.jpg'),
    description: 'Tourelles de fonville',
  },
  {
    original: require('./assets/gdc/lieux/nainville-77b.jpg'),
    description: 'Chateau de Nainville',
  },
  {
    original: require('./assets/gdc/lieux/merinos.jpg'),
    description: 'Bergerie du Merinos',
  },
  {
    original: require('./assets/gdc/lieux/archangele.jpeg'),
    description: 'Archangele',
  },
  {
    original: require('./assets/gdc/lieux/maison-blanche.jpg'),
    description: 'Chateau Maison blanche',
  },
  {
    original: require('./assets/gdc/lieux/21-roche-couloir.jpg'),
    description: 'La roche couloir',

  },

  {
    original: require('./assets/gdc/lieux/10-hirondelles.jpg'),
    description: 'Domaine des hirondelles',
  },
];




render(
  <ImageGallery 
    items={images} 
    showPlayButton={false}
    autoPlay={false}
    showFullscreenButton={false}
    preventDefaultTouchmoveEvent={true}
    showThumbnails={false}
    slideInterval={6000}
    onSlide={(slideIndex) => {
      console.log(slideIndex);
      
      const elements = document.querySelectorAll(".avis-action");
      elements.forEach(elm => {
        elm.classList.remove('show')
        elm.classList.add('none');
      })
      
      
      const openSlide = document.querySelector(".avis-"+slideIndex);
      openSlide.classList.remove('none')
      openSlide.classList.add('show');


    }}
  ></ImageGallery>,
  document.querySelector(".gallery")
);


